<template>
    <div
        class="relative w-full"
        :class="aspect_ratio_classes"
    >
        <div
            :style="{
                'background-image': `url(${src})`
            }"
            class="absolute inset-0 h-full bg-white bg-center bg-cover rounded bg-grey-lightest"
        />
    </div>
</template>

<script>
    import _ from 'lodash'

    export default {
        props: {
            src: {
                type: String,
                required: true
            },
            aspectRatio: {
                default: '16/9',
                validator: value => typeof value === 'string' || typeof value === 'object'
            }
        },
        computed: {
            aspect_ratio_classes () {
                if (_.isString(this.aspectRatio)) {
                    return `aspect-ratio-${this.aspectRatio}`
                }

                return _.chain(this.aspectRatio)
                    .map((value, key) => {
                        key = key === 'default' ? '' : `${key}:`

                        return `${key}aspect-ratio-${value}`
                    })
                    .join(' ')
                    .value()
            }
        }
    }
</script>
